import { render, staticRenderFns } from "./history.vue?vue&type=template&id=be2b1126&scoped=true&lang=html&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2b1126",
  null
  
)

export default component.exports